import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js'
import React from 'react'
import { Bar } from 'react-chartjs-2'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const StakedChart = (data: any) => {
  const dataChart = data?.data
  const chartData = {
    labels: ['Total User', 'Total Staked', 'Pool Cap', 'Remaining Pool'],
    datasets: [
      {
        // label: 'Staked Overview',
        data: [
          dataChart?.totalUser,
          dataChart?.totalStaked,
          dataChart?.poolCap,
          dataChart?.remainingPool,
        ],
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
        borderColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
        borderWidth: 1,
      },
    ],
  }

  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      // title: { display: true, text: 'Staked Overview' },
    },
    scales: {
      y: { beginAtZero: true },
    },
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Bar data={chartData} options={options} />
    </div>
  )
}

export default StakedChart
